import SiteFooter from "@/components/feature/SiteFooter";
import SiteHeader from "@/components/feature/SiteHeader";
import BackToTop from "@/components/feature/BackToTop";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import AboutIntro from "./components/AboutIntro";
import AboutValues from "./components/AboutValues";
import AboutContactForm from "./components/AboutContactForm";
import { contactEmail, siteName, siteTagline } from "@/mocks/site";

export default function AboutPage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "AboutPage",
        name: `关于我们 | ${siteName}`,
        description:
          "黑料八卦网的品牌介绍、网站定位、发展理念与内容原则，以及线索投稿与联系方式。",
        inLanguage: "zh-CN",
      },
      {
        "@type": "Organization",
        name: siteName,
        description: siteTagline,
        email: contactEmail,
      },
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://billionan.cn/" },
          { "@type": "ListItem", position: 2, name: "关于我们" },
        ],
      },
    ],
  };

  return (
    <>
      <title>关于我们 | 黑料八卦网 内容原则与线索投稿方式</title>
      <meta
        name="description"
        content="了解黑料八卦网的品牌定位、发展理念与内容原则：可核查优先、匿名表述、讲脉络而非结论、持续更新。欢迎通过投稿邮箱或在线表单提交线索。"
      />
      <meta name="keywords" content="黑料八卦网,关于我们,内容原则,线索投稿,娱乐爆料" />
      <link rel="canonical" href="https://billionan.cn/about" />
      <meta name="robots" content="index,follow" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="关于我们 | 黑料八卦网" />
      <meta
        property="og:description"
        content="了解我们的品牌定位、发展理念与内容原则，以及线索投稿与联系方式。"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />

      <SiteHeader />
      <main>
        <div className="mx-auto max-w-content px-4 pt-6 md:px-6">
          <Breadcrumbs items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
        </div>
        <AboutIntro />
        <AboutValues />
        <AboutContactForm />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}